import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePhase} from '../hooks/usePhase.ts';
import {usePhasesSelection} from '../hooks/usePhasesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

// TODO: import {IndexPage as StepsPage} from "../../steps/pages/IndexPage.tsx";
// The `steps` module is being scaffolded in a parallel task (FNP-85 sibling story).
// Once it lands, uncomment the import above and render <StepsPage/> in the right-hand
// Grid.Col below in place of the placeholder SimplePageContentWrapper.

export const EditPage = () => {

    // Route pattern is /playbooks/:id/phases/:phaseId — :id is the playbookId,
    // :phaseId is this phase's id.
    const {id: playbookId, phaseId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId is required parameter');
    }

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/playbooks/${playbookId}/phases/${phaseId}`);
    }

    const {
        record: phase,
        updateRecord,
    } = usePhase(phaseId);

    const {handleClearSelection} = usePhasesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (!phase) {
        return <PlatformLoader message='Loading phase...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={phase.displayName ? phase.displayName : phase.name ? phase.name : phase.id}
            pageNavigation={<EditPageNavigation component={phase}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 3
                    }}>
                        <Profile record={phase}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 9
                    }}>
                        <SimplePageContentWrapper>
                            {/* TODO: render <StepsPage/> here once the steps module is scaffolded (FNP-85 sibling story).
                                It will consume useParams() and read :phaseId for its filter. */}
                            <div>Steps for this phase will appear here.</div>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={phase}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
